module.exports = __webpack_public_path__ + "static/Smartphone-a4384ff7fc944e095119f6166f2a6f2d.png";